export default __webpack_public_path__ + "static/media/logo.5b600a28.svg";